<template>
  <!--
      	作者：zhuchangtao
      	时间：2020-12-30
      	描述：插件中心-素材
      -->
    <div class="user">
        <div class="common-seach-wrap">
            <el-tabs v-model="activeName">
                <el-tab-pane label="" name="list">
                    <span slot="label">活动管理 <span class="red">({{waitSettled.activity_count>99?'99+':waitSettled.activity_count}})</span> </span>
                    <List v-if="activeName=='list'"></List>
                </el-tab-pane>
                <el-tab-pane label="报名记录" name="log">
                    <span slot="label">报名记录 <span class="red">({{waitSettled.activity_log_count>99?'99+':waitSettled.activity_log_count}})</span> </span>
                    <Log v-if="activeName=='log'"></Log>
                </el-tab-pane>
                <el-tab-pane label="设置" name="setting">
                    <Setting v-if="activeName == 'setting'"></Setting>
                </el-tab-pane>
                <!-- <el-tab-pane label="分类管理" name="category">
                    <Category v-if="activeName=='category'"></Category>
                </el-tab-pane> -->
                <!-- <el-tab-pane label="设置" name="setting">
                    <Setting v-if="activeName == 'setting'"></Setting>
                </el-tab-pane>
                <el-tab-pane label="素材关联订单" name="order">
                    <Order v-if="activeName == 'order'"></Order>
                </el-tab-pane> -->
            </el-tabs>
        </div>
    </div>
</template>

<script>
    import List from './list.vue';
    import Log from './log.vue';
    import Setting from './setting/Setting';
    import DataApi from '@/api/data.js';
    export default {
        components: {
            List,
            Log,
            Setting
        },
        data() {
          return {
              activeName: 'list',
              /*是否加载完成*/
              loading: true,
              waitSettled:{
                order_count:0,
                order_refund_count:0,
                diary_count:0,
                diary_comment_count:0,
                activity_count:0,
                activity_log_count:0,
            }
          }
        },
        created() {
            this.getData()

        },
        methods: {
            getData() {
                let self = this;
                DataApi.getWaitSettled({}, true)
                    .then(res => {
                    self.waitSettled = res.data.list;
                })
                .catch(error => {});
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/plus/activity/activity/index.vue